var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.327,
    height: 22.054,
    viewBox: "0 0 30.327 22.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(-0.249 -4.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24820",
    "data-name": "Path 24820",
    d: "M15.413,4.75c.906,0,8.917.016,11.174.567l.044.012a4.778,4.778,0,0,1,3.326,3.429q.01.041.018.082a38.026,38.026,0,0,1,.6,6.966,38.027,38.027,0,0,1-.6,6.86q-.007.041-.018.082a4.778,4.778,0,0,1-3.326,3.429l-.017,0c-2.269.607-10.293.624-11.2.624s-8.932-.018-11.2-.624l-.007,0A4.793,4.793,0,0,1,.879,22.886q-.017-.06-.028-.12A38.025,38.025,0,0,1,.25,15.8a38.03,38.03,0,0,1,.6-6.911q.007-.041.018-.082A4.778,4.778,0,0,1,4.2,5.379l.017,0C6.481,4.768,14.505,4.75,15.413,4.75ZM25.971,7.74c-1.7-.4-8.19-.49-10.558-.49-3.425,0-9.053.143-10.546.537A2.272,2.272,0,0,0,3.3,9.378,35.522,35.522,0,0,0,2.75,15.8s0,.009,0,.014a35.519,35.519,0,0,0,.55,6.444,2.279,2.279,0,0,0,1.562,1.511c1.484.395,7.121.538,10.551.538s9.053-.143,10.546-.537a2.272,2.272,0,0,0,1.563-1.592,35.522,35.522,0,0,0,.554-6.369s0-.008,0-.012a35.517,35.517,0,0,0-.554-6.466A2.272,2.272,0,0,0,25.971,7.74Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24821",
    "data-name": "Path 24821",
    d: "M14.625,22.242a1.25,1.25,0,0,1-1.25-1.25V12.72a1.25,1.25,0,0,1,1.868-1.087l7.273,4.136a1.25,1.25,0,0,1,0,2.173l-7.273,4.136A1.249,1.249,0,0,1,14.625,22.242Zm1.25-7.373v3.974l3.494-1.987Z",
    transform: "translate(-2.058 -1.054)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fceeb3ab5d571b6cc40d60f8d52915a8.svg";
export { ForwardRef as ReactComponent };